(function () {
  'use strict';

  angular.module('app').component('bookingItemDetail', bookingItemDetail());

  function bookingItemDetail() {
    return {
      bindings: {
        productType: '<',
        item: '=',
        booking: '<',
        documentDateExchangeRate: '<',
        currencies: '<',
        companyBaseCurrencyId: '<',
        onBookingItemSaved: '&',
        onBookingItemCanceled: '&',
      },
      controller: BookingItemDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-detail/booking-item-detail.component.html',
    };
  }

  BookingItemDetailComponent.$inject = [
    'CONFIGURATIONS',
    '$filter',
    '$location',
    'UtilService',
    'moment',
    'TourService',
    'TourInventoryService',
    'TransportationService',
    'TransportationInventoryService',
    'AvailabilityService',
    'TaxService',
    'ExchangeRateService',
    'PriceListService',

    // Angular downgraded service
    'pickupPlaceService',
  ];

  function BookingItemDetailComponent(
    config,
    $filter,
    $location,
    UtilService,
    moment,
    TourService,
    TourInventoryService,
    TransportationService,
    TransportationInventoryService,
    AvailabilityService,
    TaxService,
    ExchangeRateService,
    PriceListService,

    // Angular downgraded service
    pickupPlaceService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.datePickerMinDate = moment();

    vm.productSelected = null;

    vm.inventoryAvailability = null;

    // private properties
    // -----------------------
    let dateDBDisplay = config.DATE_FORMAT_DB;

    vm.$onInit = function () {
      if (vm.item.id) {
        // view - edit
        vm.editMode = true;

        vm.bookedTotalPax = angular.copy(
          vm.item.adults + vm.item.children + vm.item.seniors + vm.item.infants
        );

        vm.selectedMonth = moment(vm.item.start_date);
        vm.selectedDate = vm.item.start_date;
      } else {
        // New
        resetSelectedValues();
        vm.bookedTotalPax = 0;

        vm.item = {
          adults: 2,
          children: 0,
          infants: 0,
          seniors: 0,
        };

        vm.showProductsSearch = true;

        vm.selectedMonth = moment();
        vm.selectedDate = '';

        if (vm.booking.price_list.related_price_list_id) {
          getBookingItemPriceList();
        } else {
          getDefaultPriceListForProviders();
        }
      }

      vm.selectedMonthFormat = vm.selectedMonth.format('MMMM, YYYY'); // February, 2019

      selectProductType(vm.productType);
    };

    // public methods
    // -----------------------
    vm.selectPickUp = function (pickup) {
      if (vm.pickUpSelected && vm.pickUpSelected.id === pickup.id) {
        return;
      }

      vm.pickUpSelected = pickup;

      vm.item.pickup_name = pickup.name;

      if (vm.item.dropoff_place_id) {
        getProductInventory();
      }
    };

    vm.selectDropOff = function (dropoff) {
      if (vm.dropOffSelected && vm.dropOffSelected.id === dropoff.id) {
        return;
      }

      vm.dropOffSelected = dropoff;

      vm.item.dropoff_name = dropoff.name;

      if (vm.item.pickup_place_id) {
        getProductInventory();
      }
    };

    vm.changePax = function () {
      if (
        vm.item.dropoff_place_id &&
        (vm.item.tour_option_schedule_id || vm.item.transportation_schedule_id)
      ) {
        getProductInventory();
      }
    };

    // Changes the year and month of the global date
    // This is evaluated when vm.calendarPicker is fired, as change method in component
    vm.changeYearMonth = function (newValue, oldValue) {
      vm.selectedMonthFormat = vm.selectedMonth.format('MMMM, YYYY');

      getProductInventory();
    };

    vm.goCurrentMonth = function () {
      vm.selectedMonth = moment(); // This evaluates vm.changeYearMonth()
    };

    vm.goPreviousMonth = function () {
      vm.selectedMonth.subtract(1, 'months'); // This evaluates vm.changeYearMonth()
    };

    vm.goNextMonth = function () {
      vm.selectedMonth.add(1, 'months'); // This evaluates vm.changeYearMonth()
    };

    vm.cancel = function () {
      vm.onBookingItemCanceled();
    };

    vm.onTourOptionScheduleSelected = function (tour, tourOption, tourOptionSchedule) {
      // When tour has the same location has previous tour selected
      if (
        !vm.productSelected ||
        (vm.productSelected && vm.productSelected.location_id !== tour.location_id)
      ) {
        let locationParams = {
          location_id: tour.location_id,
        };

        getPlacesByProductLocation(tour, locationParams);
      }

      vm.productSelected = tour; // important

      vm.item.tour_option_id = tourOption.id;
      vm.item.tour_option_schedule_id = tourOptionSchedule.id;
      vm.item.departure_time = tourOptionSchedule.departure;

      vm.item.provider_id = vm.editMode ? vm.item.provider_id : tour.default_provider_id; // Edit / new

      vm.scheduleMaxPaxAllowed = tourOptionSchedule.max_pax_allowed;
      vm.scheduleMinPaxRequired = tourOptionSchedule.min_pax_required;

      vm.productCostType = 'per_person';

      if (
        (vm.pickUpSelected && vm.pickUpSelected.location_id !== tour.location_id) ||
        (vm.dropOffSelected && vm.dropOffSelected.location_id !== tour.location_id)
      ) {
        vm.item.pickup_place_id = null;
        vm.item.dropoff_place_id = null;
      }

      vm.item.pickup_time = vm.UtilService.setDurationTime(vm.item.departure_time);

      // console.log(vm.item.departure_time);
      // console.log(vm.item.pickup_time);

      // vm.checkPickupTime(vm.item.pickup_time);

      if (vm.item.pickup_place_id && vm.item.dropoff_place_id) {
        getProductInventory();
      }
    };

    vm.onTransportationScheduleSelected = function (transportation, transportationSchedule) {
      let locationParams = {
        departure_location_id: transportation.departure_location_id,
        arrival_location_id: transportation.arrival_location_id,
      };

      getPlacesByProductLocation(transportation, locationParams);

      vm.productSelected = transportation; // important

      vm.item.transportation_schedule_id = transportationSchedule.id;
      vm.item.departure_time =
        transportation.schedule_type === 'open'
          ? vm.UtilService.setDurationTime(transportationSchedule.departure)
          : transportationSchedule.departure;

      vm.item.provider_id = vm.editMode ? vm.item.provider_id : transportation.default_provider_id; // Edit / new

      vm.scheduleMaxPaxAllowed = transportationSchedule.max_pax_allowed;
      vm.scheduleMinPaxRequired = transportationSchedule.min_pax_required;

      vm.productCostType = transportation.schedule_type === 'open' ? 'per_service' : 'per_person';

      vm.item.pickup_place_id = null;
      vm.item.dropoff_place_id = null;

      vm.item.pickup_time = vm.UtilService.setDurationTime(vm.item.departure_time);
      // vm.checkPickupTime(vm.item.pickup_time);

      if (vm.item.pickup_place_id && vm.item.dropoff_place_id) {
        getProductInventory();
      }
    };

    vm.addPickUpPlaces = function () {
      $location.path('/pickup_places');
      document.body.style.overflow = 'scroll';
    };

    vm.onProductAddedToBookingItem = function (bookingItemObj) {
      // console.log(bookingItemObj); return;

      if (vm.pickUpTimeError) return;

      let bookingItem = bookingItemObj;

      if (vm.editMode) {
        bookingItem.id = vm.item.id;
      }

      bookingItem.booking_type = vm.item.booking_type;
      bookingItem.adults = vm.item.adults;
      bookingItem.children = vm.item.children;
      bookingItem.infants = vm.item.infants;
      bookingItem.seniors = vm.item.seniors;
      bookingItem.pickup_place_id = vm.item.pickup_place_id;
      bookingItem.dropoff_place_id = vm.item.dropoff_place_id;
      bookingItem.provider_id = vm.item.provider_id;
      bookingItem.price_list_id = vm.item.price_list_id; // for provider
      bookingItem.start_date = bookingItemObj.full_date;

      // bookingItem.pickup_time = vm.item.pickup_time;
      bookingItem.is_private_service = vm.item.is_private_service; // hotel ?

      let transactionTaxes = bookingItem.purchase_taxes.concat(bookingItem.sale_taxes);

      if (transactionTaxes.length > 0) {
        bookingItem.transaction_taxes = transactionTaxes;
      }

      var quantity = vm.item.adults + vm.item.children + vm.item.infants + vm.item.seniors;

      switch (vm.item.booking_type) {
        case 'tour':
          bookingItem.tour_id = vm.productSelected.id;
          bookingItem.tour_option_id = vm.item.tour_option_id;
          bookingItem.tour_option_schedule_id = vm.item.tour_option_schedule_id;
          bookingItem.departure_time = vm.item.departure_time;

          bookingItem.pickup_time = $filter('date')(vm.item.pickup_time, 'HH:mm');

          break;
        case 'transportation':
          bookingItem.transportation_id = vm.productSelected.id;
          bookingItem.transportation_schedule_id = vm.item.transportation_schedule_id;

          if (vm.productSelected.schedule_type === 'open') {
            bookingItem.departure_time = $filter('date')(vm.item.departure_time, 'HH:mm');
            quantity = 1;
          } else {
            bookingItem.departure_time = vm.item.departure_time;
          }

          bookingItem.pickup_time = $filter('date')(vm.item.pickup_time, 'HH:mm');

          break;
      }

      bookingItem.quantity = quantity;

      // if (bookingItemObj.booking_item_service_items){
      // bookingItem.booking_item_service_items = bookingItemObj.booking_item_service_items;
      if (vm.item.based_on_service_items && vm.item.booking_item_service_items.length > 0) {
        bookingItem.bookingItemUpdated = true; // For updating service item in the API
        // bookingItem.booking_item_service_items = vm.item.booking_item_service_items;
      }

      bookingItem.is_custom_cost = false;
      bookingItem.is_custom_price = false;

      // vm.checkPickupTime(vm.item.pickup_time);
      // if (vm.pickUpTimeError) return;

      vm.onBookingItemSaved({ booking_item: bookingItem });
    };

    vm.checkPickupTime = function (pickupTimeSelected) {
      if (vm.item.departure_time && vm.item.pickup_time) {
        let departureTime = vm.UtilService.setDurationTime(vm.item.departure_time);
        let pickUpTime = pickupTimeSelected;

        // console.log('departureTime: ', departureTime);
        // console.log('pickUpTime: ', pickUpTime);

        // To avoid seconds
        const dep = moment(departureTime).format('MMM DD, YYYY | hh:mm');
        const pick = moment(pickUpTime).format('MMM DD, YYYY | hh:mm');

        // console.log(dep);
        // console.log(pick);

        // if (departureTime < pickUpTime) {
        if (dep < pick) {
          vm.pickUpTimeError = true;
        } else {
          vm.pickUpTimeError = false;
        }
        // <=
      } else {
      }
    };

    // private methods
    // -----------------------
    function getBookingItemPriceList() {
      PriceListService.getPriceList(vm.booking.price_list.related_price_list_id).then(function (
        data
      ) {
        vm.item.price_list = data;
        vm.item.price_list_id = data.id;
      });
    }

    function getDefaultPriceListForProviders() {
      let params = {
        get: 'active',
        contact_type: 'provider',
        skip_check_role: true,
      };

      PriceListService.getPriceLists(params).then(function (data) {
        let defaultPriceListForProvider = data.items.find((priceList) => priceList.is_default);

        vm.item.price_list = defaultPriceListForProvider;
        vm.item.price_list_id = defaultPriceListForProvider.id;
      });
    }

    function getPlacesByProductLocation(product, locationParams) {
      let params = {
        get: 'active',
        skip_check_role: true,
      };

      // let filterCriteria = { ...params, ...locationParams }; // Not working in grunt concact
      let filterCriteria = Object.assign({}, params, locationParams);

      vm.loadingPlacesByProduct = true;
      pickupPlaceService.getPickupPlaces(params).subscribe((response) => {
        let placesByLocation = response;

        if (vm.productType === 'tour') {
          vm.pickupPlacesByProductLocation = placesByLocation.filter(
            (place) => place.location_id === product.location_id
          );
          vm.dropoffPlacesByProductLocation = vm.pickupPlacesByProductLocation;
        } else if (vm.productType === 'transportation') {
          vm.pickupPlacesByProductLocation = placesByLocation.filter(
            (place) => place.location_id === product.departure_location_id
          );
          vm.dropoffPlacesByProductLocation = placesByLocation.filter(
            (place) => place.location_id === product.arrival_location_id
          );
        }

        // console.log(placesByLocation);
        // console.log(vm.pickupPlacesByProductLocation);
        // console.log(vm.dropoffPlacesByProductLocation);

        vm.loadingPlacesByProduct = false;
      });
    }

    // TODO: we can only get the tour booked and only change option or schedule
    function selectProductType(productType) {
      resetSelectedValues();

      vm.item.booking_type = productType;

      switch (productType) {
        case 'tour':
          vm.productSelectedLabel = 'TOUR';
          vm.productSelectedIcon = 'binoculars';

          if (vm.editMode) {
            vm.item.pickup_time = vm.UtilService.setDurationTime(vm.item.pickup_time);

            getTour();
          }
          // else {
          // vm.item.pickup_time = vm.UtilService.setDurationTime();
          // }

          // vm.checkPickupTime(vm.item.pickup_time);

          break;
        case 'transportation':
          vm.productSelectedLabel = 'TRANSPORTATION';
          vm.productSelectedIcon = 'truck';

          if (vm.editMode) {
            vm.item.pickup_time = vm.UtilService.setDurationTime(vm.item.pickup_time);

            getTransportation();
          }
          // else {
          // vm.item.pickup_time = vm.UtilService.setDurationTime();
          // }

          // vm.checkPickupTime(vm.item.pickup_time);

          break;
      }
    }

    function resetSelectedValues() {
      vm.productSelected = null;

      if (!vm.item.id) {
        // New
        vm.item.pickup_place_id = null;
        vm.item.dropoff_place_id = null;
      }

      vm.scheduleMaxPaxAllowed = 99;
      vm.scheduleMinPaxRequired = 0;
    }

    // TODO: use only on call to api - same as hotel
    // getTourAvailabilitySchedule
    function getProductInventory() {
      vm.checkPickupTime(vm.item.pickup_time);

      // TODO: If it is invalid, I cannot do anything
      // if (vm.pickUpTimeError) return;

      vm.totalPax = vm.item.adults + vm.item.children + vm.item.seniors + vm.item.infants;

      if (vm.totalPax >= vm.scheduleMinPaxRequired && vm.totalPax <= vm.scheduleMaxPaxAllowed) {
        vm.scheduleMaxPaxAllowedError = false;

        let filter = {
          product_type: vm.item.booking_type,
          pickup_id: vm.item.pickup_place_id,
          dropoff_id: vm.item.dropoff_place_id,
          provider_id: vm.item.provider_id,
          booking_item_price_list_id: vm.item.price_list_id,

          client_id: vm.booking.client_id,
          price_list_id: vm.booking.price_list_id,
          company_id: vm.booking.company_id,

          adults: vm.item.adults,
          children: vm.item.children,
          infants: vm.item.infants,
          seniors: vm.item.seniors,

          skip_check_role: true,
          startDay: null,
          endDay: null,
          tour_id: null,
          tour_option_id: null,
          tour_option_schedule_id: null,
          transportation_id: null,
          transportation_schedule_id: null,
        };

        // filter.startDay = vm.selectedMonth.startOf('month').format('YYYY-MM-DD'); // 2020-09-01
        // filter.endDay   = vm.selectedMonth.endOf('month').format('YYYY-MM-DD');   // 2020-10-01

        // filter.startDay = moment().startOf('month').format('YYYY-MM-DD');                 // 2020-09-01
        // filter.endDay   = moment().startOf('month').add(1, 'month').format('YYYY-MM-DD'); // 2020-10-01

        filter.startDay = moment(vm.selectedMonth).utc().startOf('month').toISOString(); // 2020-09-01T00:00:00.000Z
        filter.endDay = moment(vm.selectedMonth).utc().endOf('month').toISOString(); // 2020-09-30T23:59:59.999Z

        // vm.loadingInventory = true;
        switch (vm.item.booking_type) {
          case 'tour':
            filter.tour_id = vm.productSelected.id;
            filter.tour_option_id = vm.item.tour_option_id;
            filter.tour_option_schedule_id = vm.item.tour_option_schedule_id;

            TourInventoryService.getTourInventory(filter).then(function (data) {
              vm.invalidServiceItemsSchedulesApplied =
                TourService.checkServiceItemsSchedulesApplied(data.tour);

              if (!vm.invalidServiceItemsSchedulesApplied) {
                vm.inventory = data.schedule;

                getAvailability(filter);
              }

              // vm.loadingInventory = false;
            });
            break;
          case 'transportation':
            filter.transportation_id = vm.productSelected.id;
            filter.transportation_schedule_id = vm.item.transportation_schedule_id;

            TransportationInventoryService.getTransportationInventory(filter).then(function (data) {
              if (
                data.transportation.service_items_cost_based &&
                data.transportation.associated_service_items.length === 0
              ) {
                vm.invalidServiceItemsSchedulesApplied = true;
              }

              if (!vm.invalidServiceItemsSchedulesApplied) {
                vm.inventory = data.schedule;

                getAvailability(filter);
              }

              // vm.loadingInventory = false;
            });
            break;
        }
      } else {
        vm.scheduleMaxPaxAllowedError = vm.totalPax <= vm.scheduleMaxPaxAllowed ? true : false;
      }
    }

    let applyExchangeRateConversion = (amount) => {
      return ExchangeRateService.applyExchangeRateConversion(amount, vm.documentDateExchangeRate);
    };

    function getAvailability(filter) {
      vm.schedule = setCalendar();

      let inventory;
      let itemAvailability;
      let bookedTotalPax;

      vm.loadingAvailability = true;

      AvailabilityService.getAvailabilitySchedule(filter).then(function (data) {
        // console.log(data);
        vm.extraPricesApplied = false;
        vm.schedule.forEach(function (week) {
          week.days.forEach(function (day) {
            day.isAvailable = false;
            day.totalPaxExceeded = false;
            day.currentBookingItemDate = false;
            day.showInCalendar = false;

            for (let i = 0; i < vm.inventory.length; i++) {
              inventory = vm.inventory[i];
              bookedTotalPax = 0;

              if (day.full_date === inventory.day) {
                day.totalBlockings = inventory.total_blockings;
                day.totalAvailability = inventory.total_availability;

                // Current item booking date
                if (vm.item.id && vm.item.start_date === inventory.day) {
                  day.currentBookingItemDate = true;
                  bookedTotalPax =
                    vm.totalPax < vm.bookedTotalPax
                      ? vm.totalPax + vm.bookedTotalPax
                      : vm.bookedTotalPax;
                }

                day.totalAvailable =
                  day.totalAvailability +
                  bookedTotalPax -
                  (inventory.total_blockings + inventory.total_bookings);

                if (
                  (day.totalAvailable > 0 ||
                    (day.totalAvailable === 0 && day.currentBookingItemDate)) &&
                  day.totalAvailable < vm.totalPax - bookedTotalPax
                ) {
                  day.totalPaxExceeded = true;
                }

                day.showInCalendar = moment(inventory.day).isSameOrAfter(
                  moment().format(dateDBDisplay),
                  'day'
                );

                // console.log(moment(inventory.day));

                day.has_inventory = inventory.has_inventory;

                break;
              }
            }

            for (let i = 0; i < data.length; i++) {
              itemAvailability = data[i];

              if (day.full_date === itemAvailability.date) {
                day.item_price = 0;
                if (itemAvailability.prices.item_price) {
                  let productCost = itemAvailability.costs.item_cost;
                  let productPrice = itemAvailability.prices.item_price;

                  if (vm.productCostType === 'per_person') {
                    if (!vm.productSelected.service_items_cost_based) {
                      day.adult_cost =
                        vm.item.adults > 0
                          ? applyExchangeRateConversion(productCost.adult_cost)
                          : 0;
                      day.child_cost =
                        vm.item.children > 0
                          ? applyExchangeRateConversion(productCost.child_cost)
                          : 0;
                      day.infant_cost =
                        vm.item.infants > 0
                          ? applyExchangeRateConversion(productCost.infant_cost)
                          : 0;
                      day.senior_cost =
                        vm.item.seniors > 0
                          ? applyExchangeRateConversion(productCost.senior_cost)
                          : 0;
                    }

                    day.adult_price =
                      vm.item.adults > 0
                        ? applyExchangeRateConversion(productPrice.adult_price)
                        : 0;
                    day.child_price =
                      vm.item.children > 0
                        ? applyExchangeRateConversion(productPrice.child_price)
                        : 0;
                    day.infant_price =
                      vm.item.infants > 0
                        ? applyExchangeRateConversion(productPrice.infant_price)
                        : 0;
                    day.senior_price =
                      vm.item.seniors > 0
                        ? applyExchangeRateConversion(productPrice.senior_price)
                        : 0;
                  }

                  // Product taxes based on service date
                  let serviceDate = moment(inventory.day);
                  let productTaxes = TaxService.setProductTaxes(vm.productSelected, serviceDate);

                  // Costs
                  // -----------
                  let productPurchaseTaxes = productTaxes.purchaseTaxes;

                  let item_cost = setDayCostPrice(productCost, vm.productCostType, 'cost');
                  let base_cost = TaxService.setBaseCostPrice(
                    item_cost,
                    vm.item.price_list,
                    productPurchaseTaxes
                  );

                  let net_cost = base_cost;
                  let pickup_cost = itemAvailability.costs.pickup_cost;
                  let dropoff_cost = itemAvailability.costs.dropoff_cost;
                  let discount_cost = 0;
                  let subtotal_cost = net_cost + pickup_cost + dropoff_cost - discount_cost;
                  let tax_cost_percentage =
                    TaxService.getProductTaxesTotalPercentage(productPurchaseTaxes);
                  let tax_exoneration_cost_percentage =
                    TaxService.getProductTaxesTotalExonerationPercentage(productPurchaseTaxes);
                  let net_tax_cost_percentage =
                    tax_cost_percentage - tax_exoneration_cost_percentage;

                  day.purchase_taxes = TaxService.setProductTaxesAmounts(
                    subtotal_cost,
                    productPurchaseTaxes
                  );

                  let tax_cost = TaxService.getProductTaxesTotalAmount(day.purchase_taxes);
                  let tax_exoneration_cost = TaxService.getProductTaxesTotalExonerationAmount(
                    day.purchase_taxes
                  );
                  let net_tax_cost = tax_cost - tax_exoneration_cost;

                  let total_cost = subtotal_cost + net_tax_cost; // net_cost

                  day.item_cost = vm.UtilService.roundNum(item_cost);
                  day.base_cost = vm.UtilService.roundNum(base_cost);
                  day.net_cost = vm.UtilService.roundNum(net_cost);
                  day.pickup_cost = applyExchangeRateConversion(pickup_cost);
                  day.dropoff_cost = applyExchangeRateConversion(dropoff_cost);
                  day.discount_cost = vm.UtilService.roundNum(discount_cost); // conversion needed *
                  day.subtotal_cost = vm.UtilService.roundNum(subtotal_cost);
                  day.tax_cost_percentage = tax_cost_percentage;
                  day.tax_cost = vm.UtilService.roundNum(tax_cost);
                  day.tax_exoneration_cost_percentage = tax_exoneration_cost_percentage;
                  day.tax_exoneration_cost = vm.UtilService.roundNum(tax_exoneration_cost);
                  day.net_tax_cost_percentage = net_tax_cost_percentage;
                  day.net_tax_cost = vm.UtilService.roundNum(net_tax_cost);
                  day.total_cost = vm.UtilService.roundNum(total_cost);

                  // Prices
                  // -----------
                  let productSaleTaxes = productTaxes.saleTaxes;

                  // let base_tax_price       = item_price - (item_price / ((tax_price_percentage / 100) + 1));
                  // let base_price           = item_price - base_tax_price;
                  let item_price = setDayCostPrice(productPrice, vm.productCostType, 'price');
                  let base_price = TaxService.setBaseCostPrice(
                    item_price,
                    vm.booking.price_list,
                    productSaleTaxes
                  );
                  let commission_price =
                    base_price * (productPrice.client_commission_percentage / 100);
                  let net_price = base_price - commission_price;
                  let pickup_price = itemAvailability.prices.pickup_price;
                  let dropoff_price = itemAvailability.prices.dropoff_price;
                  let discount_price = 0;
                  let subtotal_price = net_price + pickup_price + dropoff_price - discount_price;
                  let tax_price_percentage =
                    TaxService.getProductTaxesTotalPercentage(productSaleTaxes);
                  let tax_exoneration_price_percentage =
                    TaxService.getProductTaxesTotalExonerationPercentage(productSaleTaxes);
                  let net_tax_price_percentage =
                    tax_price_percentage - tax_exoneration_price_percentage;

                  // console.log(tax_price_percentage);
                  // console.log(tax_exoneration_price_percentage);
                  // console.log(net_tax_price_percentage);

                  if (vm.booking.discount_coupon_id) {
                    if (vm.booking.discount_coupon.discount_type === 'percentage') {
                      discount_price = subtotal_price * (vm.booking.discount_coupon.value / 100);
                      subtotal_price = subtotal_price - discount_price;
                    } else {
                      // discount_price = vm.booking.discount_coupon.value; // 1000 fixed amount
                      discount_price = applyExchangeRateConversion(
                        vm.booking.discount_coupon.value
                      );
                      subtotal_price =
                        (item_price + pickup_price + dropoff_price - discount_price) /
                        (net_tax_price_percentage / 100 + 1); // tax_price_percentage
                    }
                  }

                  day.sale_taxes = TaxService.setProductTaxesAmounts(
                    subtotal_price,
                    productSaleTaxes
                  );

                  let tax_price = TaxService.getProductTaxesTotalAmount(day.sale_taxes);
                  let tax_exoneration_price = TaxService.getProductTaxesTotalExonerationAmount(
                    day.sale_taxes
                  );
                  let net_tax_price = tax_price - tax_exoneration_price;

                  let total_price = subtotal_price + net_tax_price;

                  day.item_price = vm.UtilService.roundNum(item_price);
                  day.base_price = vm.UtilService.roundNum(base_price);
                  day.commission_price_percentage = productPrice.client_commission_percentage;
                  day.commission_price = vm.UtilService.roundNum(commission_price);
                  day.net_price = vm.UtilService.roundNum(net_price);
                  day.pickup_price = applyExchangeRateConversion(pickup_price);
                  day.dropoff_price = applyExchangeRateConversion(dropoff_price);
                  day.discount_price = vm.UtilService.roundNum(discount_price);
                  day.subtotal_price = vm.UtilService.roundNum(subtotal_price);
                  day.tax_price_percentage = tax_price_percentage;
                  day.tax_price = vm.UtilService.roundNum(tax_price);
                  day.tax_exoneration_price_percentage = tax_exoneration_price_percentage;
                  day.tax_exoneration_price = vm.UtilService.roundNum(tax_exoneration_price);
                  day.net_tax_price_percentage = net_tax_price_percentage;
                  day.net_tax_price = vm.UtilService.roundNum(net_tax_price);
                  day.total_price = vm.UtilService.roundNum(total_price);

                  // console.log(day);

                  // let tax_cost   = subtotal_cost * (tax_cost_percentage / 100);
                  // let tax_price   = subtotal_price * (tax_price_percentage / 100);
                  // console.log('item_price: ', item_price);
                  // console.log('base_price: ', base_price);
                  // console.log('net_price: ', net_price);
                  // console.log('subtotal_price: ', subtotal_price);
                  // console.log('tax_price: ', tax_price);
                  // console.log('total_price: ', total_price);

                  // console.log('--------------------------------');

                  // console.log('item_price: ', day.item_price);
                  // console.log('base_price: ', day.base_price);
                  // console.log('net_price: ', day.net_price);
                  // console.log('subtotal_price: ', day.subtotal_price);
                  // console.log('tax_price: ', day.tax_price);
                  // console.log('total_price: ', day.total_price);
                }

                if (
                  day.showInCalendar &&
                  (day.totalAvailable > 0 ||
                    (day.totalAvailable === 0 && day.currentBookingItemDate)) &&
                  !day.totalPaxExceeded &&
                  day.item_price
                ) {
                  day.isAvailable = true;
                }

                if (day.pickup_price && !vm.extraPricesApplied) {
                  vm.extraPricesApplied = true;
                }

                break;
              }
            }
          });
        });

        vm.loadingAvailability = false;

        vm.inventoryAvailability = true;

        vm.isCurrentMonth = checkIsCurrentMonth();
      });

      // console.log(vm.schedule);
    }

    // Set cost / price for all paxes
    function setDayCostPrice(item, productCostType, type) {
      let amount;

      if (productCostType === 'per_person') {
        amount =
          vm.item.adults * item['adult_' + type] +
          vm.item.children * item['child_' + type] +
          vm.item.infants * item['infant_' + type] +
          vm.item.seniors * item['senior_' + type];
      } else {
        amount = item['service_' + type];
      }

      return applyExchangeRateConversion(amount);
    }

    // Tours
    function getTour() {
      let params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      TourService.getTour(vm.item.tour_id, params).then(function (data) {
        vm.tours = [data]; // hack - html

        setSelectBookingItemTour(data);
      });
    }

    function setSelectBookingItemTour(tour) {
      vm.productSelected = tour;

      vm.productCostType = 'per_person';

      let tourOptionBooked = tour.tour_options.find(
        (tourOption) => tourOption.id === vm.item.tour_option_id
      );

      let tourOptionScheduleBooked = tourOptionBooked.tour_option_schedules.find(
        (tourOptionSchedule) => tourOptionSchedule.id === vm.item.tour_option_schedule_id
      );

      vm.scheduleMaxPaxAllowed = tourOptionScheduleBooked.max_pax_allowed;
      vm.scheduleMinPaxRequired = tourOptionScheduleBooked.min_pax_required;

      let locationParams = {
        location_id: tour.location_id,
      };

      getPlacesByProductLocation(tour, locationParams);

      vm.pickUpSelected = {
        id: vm.item.pickup_place_id,
        location_id: tour.location_id,
      };

      vm.dropOffSelected = {
        id: vm.item.dropoff_place_id,
        location_id: tour.location_id,
      };

      getProductInventory();
    }

    // Transportation
    function getTransportation() {
      let params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      TransportationService.getTransportation(vm.item.transportation_id, params).then(function (
        data
      ) {
        vm.transportations = [data]; // hack - html

        setSelectBookingItemTransportation(data);
      });
    }

    function setSelectBookingItemTransportation(transportation) {
      vm.productSelected = transportation;

      vm.productCostType = transportation.schedule_type === 'open' ? 'per_service' : 'per_person';

      if (transportation.schedule_type === 'open') {
        // move selectrProduct to avoide timepocker warning - check
        vm.item.departure_time = vm.UtilService.setDurationTime(vm.item.departure_time);
      }

      let transportationScheduleBooked = transportation.transportation_schedules.find(
        (transportationSchedule) => transportationSchedule.id === vm.item.transportation_schedule_id
      );

      vm.scheduleMaxPaxAllowed = transportationScheduleBooked.max_pax_allowed;
      vm.scheduleMinPaxRequired = transportationScheduleBooked.min_pax_required;

      let locationParams = {
        departure_location_id: transportation.departure_location_id,
        arrival_location_id: transportation.arrival_location_id,
      };

      getPlacesByProductLocation(transportation, locationParams);

      vm.pickUpSelected = {
        id: vm.item.pickup_place_id,
        location_id: transportation.departure_location_id,
      };

      vm.dropOffSelected = {
        id: vm.item.dropoff_place_id,
        location_id: transportation.arrival_location_id,
      };

      getProductInventory();
    }

    function checkIsCurrentMonth() {
      return moment().isSame(vm.selectedMonth, 'month');
    }

    function setCalendar() {
      let schedule = [];

      let isSelected = (date) => {
        return moment(vm.selectedDate).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD');
      };

      let isToday = (date) => {
        return moment().isSame(moment(date), 'day');
      };

      let isInMonth = (date) => {
        return moment(date).isSame(vm.selectedMonth, 'month');
      };

      const startDay = moment(vm.selectedMonth).startOf('month').startOf('week');
      const endDay = moment(vm.selectedMonth).endOf('month').endOf('week');

      let date = startDay.clone().subtract(1, 'day'); // !important
      // let date = startDay.clone(); // !important

      let calendar = [];
      while (date.isBefore(endDay, 'day')) {
        calendar.push({
          days: new Array(7).fill(0).map(() => {
            let day = date.add(1, 'day').clone();

            return {
              date: day,
              day_number: day.date(),
              full_date: day.format('YYYY-MM-DD'),
              isInMonth: isInMonth(day),
              isToday: isToday(day),
              isSelected: isSelected(day),
            };
          }),
        });
      }

      return calendar;
    }
  }
})();

/* if (bookingItem.departure_time && bookingItem.pickup_time) {
        let departure_date = bookingItem.departure_time.split(':');
        let pick_up_date = bookingItem.pickup_time.split(':');

        if (
          Number(departure_date[0]) <= Number(pick_up_date[0]) &&
          Number(departure_date[1]) <= Number(pick_up_date[1])
        ) {
          vm.pickUpTimeError = true;
          return;
        } else {
          vm.pickUpTimeError = false;
        }
      } */
